export default "__VITE_ASSET__D0E_sPGF__"